<div class="list-container">
  <h1 class="mat-h1 rides-list-header" i18n>Community</h1>
  <div id="ridesList" class="rides-list-container">
    @if (communityItemsLoaded) {
      @for (item of communityItems; track item.id) {
        <div class="ride-container ride-event-container" [id]="item.name | removewhitespace">
          @if (item.linkedType === 'TrackedRide' || item.content.linkedType === 'PlannedRide') {
            <div id="ridesListDistanceSmall" class="distance-tab-small">
              <pii-distance-display [distanceInMeters]="item.content.totalDistanceInMeters" />
            </div>
          }
          <div class="image-container">
            <a
              id="showRideOnMap"
              [routerLink]="['/map', 'community', item.id, item.linkedType | linkedTypeToUrl, item.id]"
            >
              @if (item.linkedType === 'Collection' && item.content?.collection?.itemCount === 0) {
                <svg-icon
                  class="collection-icon empty-collection-icon"
                  src="/assets/icons/map-icons/shared/collection.svg"
                  alt="collection"
                  i18n-alt
                />
              } @else {
                <img
                  id="ridesListMapImageLarge"
                  class="responsive-img large-map-image"
                  width="690"
                  height="460"
                  loading="lazy"
                  [alt]="item.name"
                  [ngSrc]="
                    item.content.event?.coverImage?.thumbnailUrl ||
                    (item.content.contentItem?.snapshots ?? [] | snapshotToUrl: '690x460')
                  "
                />
              }
            </a>

            @if (item.linkedType === 'TrackedRide' || item.linkedType === 'PlannedRide') {
              <div id="ridesListDistanceLarge" class="distance-tab-large">
                <pii-distance-display [distanceInMeters]="item.content.totalDistanceInMeters" />
              </div>
            }
          </div>
          <div class="info-container">
            <div id="ridesListName" class="ride-name helper-truncate">{{ item.name }}</div>
            @if (item.linkedType !== 'Event') {
              <rdx-rating-display [rating]="item.communityFeedback.ratingAverage" />
            }
          </div>
        </div>
      }
    }
    @if (!communityItemsLoaded) {
      <div class="ride-container loading-panel"></div>
      <div class="ride-container loading-panel"></div>
      <div class="ride-container loading-panel"></div>
    }
    <div class="helper-align-center flex-2 cta-container">
      <div>
        <button id="postToCommunityButton" class="button primary-button" type="button" (click)="postToCommunity()" i18n>
          New Post
        </button>
        <p class="community-button-text" i18n><span>Tracked any great</span><span>rides lately?</span></p>
      </div>
    </div>
  </div>
  <div class="helper-align-right rides-list-controls-container">
    <ul class="list-inline">
      <li>
        <a
          id="planEventFromHome"
          rdcAnalytics="Plan Event"
          [routerLink]="['/community', 'public-ride-event', 'edit', '00000000-0000-0000-0000-000000000000']"
          i18n
          >Plan Event</a
        >
      </li>
      <li>
        <a
          id="viewAllCommunityItemsFromHome"
          routerLinkActive="router-link-active"
          [routerLink]="['/community', 'activity']"
          i18n
          >View All</a
        >
      </li>
    </ul>
  </div>
</div>
